import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

/**
 * Component that alerts if you click outside of it
 */
export default class OutsideAlerter extends Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = ReactDOM.findDOMNode(node);
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    try {
      const { onClickOutside } = this.props;
      if (
        this.wrapperRef &&
        this.wrapperRef.contains &&
        !this.wrapperRef.contains(event.target)
      ) {
        if (onClickOutside) onClickOutside();
      }
    } catch (err) {
      //getGeneralCatchError(err);
    }
  }

  render() {
    const childElement = React.Children.only(this.props.children);

    return React.cloneElement(childElement, { ref: this.setWrapperRef });
  }
}

OutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired
};
